<div class="variant-picker" *ngIf="visible" [class.is-disabled]="isDisabled || preloadPending">
  <button
    cdkOverlayOrigin
    #variantOrigin="cdkOverlayOrigin"
    class="variant-picker-trigger w-100 justify-content-between"
    [ngClass]="triggerClass"
    [class.is-invalid]="showSelectionError || !!preloadError"
    [attr.aria-invalid]="showSelectionError || !!preloadError"
    type="button"
    (click)="toggle()"
    [disabled]="isDisabled || preloadPending || !hasSource"
  >
    <span class="variant-picker-summary">
      <span class="text-truncate">{{ buttonLabel }}</span>
      <span class="variant-picked-values" *ngIf="selectedSummaries.length > 0">
        <span
          *ngFor="let item of selectedSummaries"
          class="variant-picked-value app-input-pill"
          [class.is-color]="isColor(item.displayType)"
          [attr.title]="isColor(item.displayType) ? item.value.value : null"
        >
          <span
            *ngIf="isColor(item.displayType)"
            class="variant-color"
            [style.background]="item.value.value"
          ></span>
          <span class="app-input-pill__label" *ngIf="!isColor(item.displayType)">{{ item.value.value }}</span>
        </span>
      </span>
    </span>
    <span class="variant-chevron" [class.is-open]="open" aria-hidden="true"></span>
  </button>

  <app-floating-dropdown
    [origin]="variantOrigin"
    [open]="open && hasSource"
    [matchTriggerWidth]="true"
    minWidth="min(28rem, calc(100vw - 1rem))"
    panelClass="p-3 variant-picker-menu"
    (openChange)="open = $event"
  >
    <ng-container *ngIf="terminalId; else attributePicker">
      <button *ngFor="let variant of posVariants" class="dropdown-item" type="button"
        [class.active]="selectedVariantId === variant.id" (click)="choosePosVariant(variant)">
        <span>{{ variant.name }}</span><span class="ms-auto text-secondary">{{ variant.price }}</span>
      </button>
      <div class="form-hint" *ngIf="!posVariants.length">No sale variants available.</div>
    </ng-container>
    <ng-template #attributePicker>
    <div class="variant-attribute" *ngFor="let line of attributeLines">
      <div class="fw-semibold small mb-1">{{ line.attribute_name }}</div>
      <div class="variant-values">
        <button
          *ngFor="let value of line.selected_values"
          class="btn btn-sm rounded-pill"
          type="button"
          [class.btn-primary]="isSelected(value.id)"
          [class.btn-secondary]="!isSelected(value.id)"
          (click)="chooseValue(line, value)"
        >
          <span
            *ngIf="line.display_type === 'color'"
            class="variant-color"
            [style.background]="value.value"
          ></span>
          <span *ngIf="line.display_type !== 'color'">{{ valueLabel(value) }}</span>
        </button>
      </div>
    </div>
    <div *ngIf="!hasAttributes" class="variant-values">
      <button *ngFor="let variant of resolvedProduct?.variants" class="dropdown-item" type="button"
        (click)="chooseVariant(variant)">
        {{ variantLabel(variant) }}
      </button>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <button class="btn btn-sm btn-secondary" type="button" (click)="clear()" [disabled]="isDisabled">
        Clear
      </button>
      <span class="text-secondary small" *ngIf="selectedVariant">{{ selectedVariant.sku || selectedVariant.code || selectedVariant.name }}</span>
    </div>
    </ng-template>
  </app-floating-dropdown>

  <div class="text-secondary small mt-1" *ngIf="preloadPending">
    Loading selected variant...
  </div>

  <div class="invalid-feedback d-block" *ngIf="preloadError && !preloadPending">
    {{ preloadError }}
  </div>

  <div class="invalid-feedback d-block" *ngIf="!preloadError && showSelectionError">
    {{ terminalId ? 'Choose an available sale variant.' : 'Pick one value for every product attribute.' }}
  </div>
</div>
